const parseDate = (date: string) => {
  const [year, month] = date.split("-");
  return `${year}-${month.padStart(2, "0")}`;
};

export default parseDate;
